import Icon from '../../Icons'

export const customStyles = {
  option: (provided, state) => ({
    ...provided,
    background: state.isSelected ? 'lightgray' : state.isFocused ? '#dbdbdb' : '',
    padding: 3,
    '&:hover': {
      backgroundColor: '#dbdbdb',
    },
    fontSize: '14px',
    color: state.isDisabled ? '#828282' : '',
  }),
  menu: (styles) => ({
    ...styles,
    zIndex: 9,
    maxHeight: '140px',
  }),
  menuList: (styles) => ({
    ...styles,
    maxHeight: '140px',
  }),
  container: (styles) => ({
    ...styles,
    width: '14vw',
    minWidth: '230px',
    maxWidth: '225px',
  }),
  control: (styles, state) => ({
    ...styles,
    fontSize: '14px',
    borderColor: '#dbdbdb',
    '&:hover': {
      borderColor: '#dbdbdb',
    },
    boxShadow: state.isFocused ? '0 0 0 0 #dbdbdb' : 0,
    background: state.isDisabled ? '#E7E7E7' : '',
    color: state.isDisabled ? '#828282' : '',
    minHeight: '40px',
  }),
  valueContainer: (styles) => ({
    ...styles,
    maxHeight: '115px',
    overflowY: 'auto',
  }),
  singleValue: (provided) => {
    const transition = 'opacity 300ms'
    return { ...provided, transition }
  },
}

export const DropdownIndicator = () => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '5px',
        width: '28px',
      }}
    >
      <Icon icon="search" fill="#dbdbdb" />
    </div>
  )
}

const arrayOfLinks = [
  { field: 'submitEventPicturesLink', title: 'Submit Event Pictures' },
  { field: 'residentSurveyLink', title: 'Resident Survey' },
  { field: 'rewardsLink', title: 'Resident Rewards Program' },
  { field: 'payRentLink', title: 'Pay Rent' },
  { field: 'submitMaintenanceRequestLink', title: 'Submit Maintenance Request' },
  { field: 'amenityReservationLink', title: 'Amenity Reservation' },
  { field: 'amenityReservationEmail', title: 'Amenity Reservation Concierge' },
  { field: 'amenitiesInfoLink', title: 'Amenity Information' },
  { field: 'onSiteServicesLink', title: 'On-Site Resident Services' },
  { field: 'buildingFaqLink', title: 'Building FAQ' },
  { field: 'residentHandbookLink', title: 'Resident Handbook' },
  { field: 'moveInPacketLink', title: 'Move-in Packet' },
  { field: 'accessControlLink', title: 'Access Control' },
  { field: 'communityGuidelinesLink', title: 'Community Guidelines' },
  { field: 'guestParkingLink', title: 'Guest Parking' },
  { field: 'moveOutPacketLink', title: 'Move-out Packet' },
  { field: 'moveInChecklistLink', title: 'Move-in Checklist' },
  { field: 'referFriendsLink', title: 'Refer Friends' },
  { field: 'wifiInformationLink', title: 'WIFI Information' },
  { field: 'residentGuideLink', title: 'Neighborhood Guide' },
  { field: 'onlineFeedbackLink', title: 'Leave Online Feedback' },
  { field: 'callFrontDesk', title: 'Call Front Desk' },
  { field: 'emailManagement', title: 'Email Management' },
  { field: 'emailLeasing', title: 'Email Leasing Office' },
  { field: 'emailConcierge', title: 'Email Concierge' },
  { field: 'importantNumbersLink', title: 'Important Phone Numbers' },
  { field: 'feedbackToManagementLink', title: 'Submit Feedback to Management' },
  { field: 'rentersInsuranceLink', title: "Renter's Insurance" },
  { field: 'securityDispatch', title: 'Security Dispatch' },
  { field: 'onsiteRetailLink', title: 'Onsite Retail' },
  { field: 'leaseRenewalLink', title: 'Lease Renewal' },
  { field: 'servicesFaqLink', title: 'Services FAQ' },
  { field: 'callVirtualConcierge', title: 'Call Virtual Concierge' },
  { field: 'emailVirtualConcierge', title: 'Email Virtual Concierge' },
  { field: 'instagramLink', title: 'Follow us: Instagram' },
  { field: 'facebookLink', title: 'Follow us: Facebook' },
  { field: 'twitterLink', title: 'Follow us: Twitter' },
  { field: 'lyftDiscountLink', title: 'Lyft Discount' },
  { field: 'uberDiscountLink', title: 'Uber Discount' },
  { field: 'grubhubDiscountLink', title: 'Grubhub Discount' },
  { field: 'bikeShareLink', title: 'Bike Share' },
  { field: 'neighborhoodPerksDiscountsLink', title: 'Neighborhood Perks & Discounts' },
  { field: 'payHoa', title: 'Pay HOA' },
  { field: 'maintenanceRequest', title: 'Pay HOA / Maintenance Request' },
  { field: 'buildingManagerPortal', title: 'Building Manager Portal' },
  { field: 'paymentPortal', title: 'Payment Portal' },
  { field: 'callVirtualAssistant', title: 'Call Virtual Personal Assistant' },
  { field: 'emailVirtualAssistant', title: 'Email Virtual Personal Assistant' },
  { field: 'websiteVirtualAssistant', title: 'Contact Virtual Personal Assistant' },
  { field: 'managementContact', title: 'Call Management' },
  { field: 'conciergeContact', title: 'Call Concierge' },
  { field: 'leasingOfficeContact', title: 'Call Leasing Office' },
  { field: 'communityPolicies', title: 'Community Policies' },
  { field: 'packageConcierge', title: 'Package Concierge' },
  { field: 'packageManagement', title: 'Package Management' },
  { field: 'serviceRequest', title: 'Service Request' },
]

const isUrl = (link) => {
  const regexp = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/
  return regexp.test(link)
}

const isEmail = (email) => {
  const regexp = /\S+@\S+\.\S+/
  return regexp.test(email)
}

const isPhoneNum = (number) => {
  const regexp = /^[0-9]+$/
  return regexp.test(number)
}

export const selectExistingLinks = (data) =>
  arrayOfLinks
    .map(({ field, title }) => {
      if (data) {
        const existingField = data[field]
        if (existingField && isUrl(existingField)) {
          return {
            link: existingField,
            title,
          }
        } else if (existingField && isPhoneNum(existingField)) {
          return {
            phone: existingField,
            title,
          }
        } else if (existingField && isEmail(existingField)) {
          return {
            email: existingField,
            title,
          }
        }
        return undefined
      }
      return undefined
    })
    .filter((item) => item)

const MAX_SYMBOLS_TO_SHOW = 70
const MAX_SYMBOLS_IN_STRING = 67

export const getCuttedString = (
  string,
  maxSymbolsToShow = MAX_SYMBOLS_TO_SHOW,
  maxSymbolsInString = MAX_SYMBOLS_IN_STRING,
) => (string.length >= maxSymbolsToShow ? `${string.slice(0, maxSymbolsInString)}...` : string)

export const START_POSITION = 1

export const EMPTY_IMAGE = { file: false, image: '' }

export const INPUT_TYPES_DROPDOWN_OPTIONS = [
  { value: 'link', label: 'Link' },
  { value: 'number', label: 'Phone number' },
  { value: 'email', label: 'Email' },
  { value: 'texting', label: 'Texting' },
  { value: 'image', label: 'Image' },
  { value: 'pdf', label: 'PDF' },
]

export const ICONS_DROPDOWN_OPTIONS = [
  { value: 'link', label: 'Link' },
  { value: 'phone', label: 'Phone number' },
  { value: 'email', label: 'Email' },
  { value: 'file', label: 'Image/PDF' },
]
